import axios from 'axios';
// import _ from "lodash"
import cartHandler from '@/services/cartHandler';
import { EventBus } from '@/plugins/eventBus';

import findIndex from 'lodash/findIndex';
import findLodash from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import remove from 'lodash/remove';
import filter from 'lodash/filter';

import CryptoJS from 'crypto-js';
import { getProxyAccessToken } from '../../plugins/cookie-plugins';

const state = {
  loading: false,
  odds_sources: [],
  bonus_rules: [],
  settings: {},
  odds_variation: true,
  bet: {
    _multiple_detail: {
      amount: 0.0,
      bonus: 0.0,
      bonus_percentage: 0,
      multiplicity: 0,
      odds_total: 0.0,
      profit: 0.0,
      winning: 0.0,
      winning_total: 0.0
    },
    _integral_detail: {
      amount: 0.0,
      amount_total: 0.0,
      bonus_percentage: 0,
      bonus_max: 0.0,
      bonus_min: 0.0,
      combinations: 0,
      multiplicity: 0,
      odds_total_max: 0.0,
      odds_total_min: 0.0,
      profit_max: 0.0,
      profit_min: 0.0,
      winning_max: 0.0,
      winning_min: 0.0,
      winning_total_max: 0.0,
      winning_total_min: 0.0
    },
    _system_detail: {
      amount_system: 0.0,
      amount_system_equal: null,
      amount_system_to_divide: null,
      bonus_max: 0.0,
      bonus_min: 0.0,
      combinations: 0,
      fixed_bases: [],
      // multiplicity: 0,
      // odds_total_max : 0.00,
      // odds_total_min : 0.00,
      // profit_max: 0.00,
      // profit_min: 0.00,
      valid_combinations_all: 0,
      winning_max: 0.0,
      winning_min: 0.0,
      winning_total_max: 0.0,
      winning_total_min: 0.0,
      winning_all: 0.0
    },

    check: true,
    errors: [],
    warnings: [],
    integral_parts: [],
    odds: [],
    system_parts: [],
    type: 'single',
    context: '',
    errors_multi_info: []
  },
  created_at: 0,
  accepting_bets: [],
  accepted_bets: [],
  accepted_with_change: [],
  rejected_bets: [],
  mobileCartOpen: false,
  combinableMarkets: [],
  isCartUpdating: false,
  isCartOpen: false
};

const getters = {
  getLoading: state => {
    return state.loading;
  },
  getOddsSources: state => {
    return state.odds_sources;
  },
  getBet: state => {
    return state.bet;
  },
  getBetSystemParts: state => {
    return state.bet.system_parts;
  },
  getSettings: state => {
    return state.settings;
  },
  getBonusRules: state => {
    return state.bonus_rules;
  },
  getOddsVariation: state => {
    return state.odds_variation;
  },
  getBetOdds: state => {
    return state.bet.odds;
  },
  getAcceptingBets: state => {
    return state.accepting_bets;
  },
  getAcceptedBets: state => {
    return state.accepted_bets;
  },
  getAcceptedBetWithChange: state => {
    return state.accepted_with_change;
  },
  getRejectedBets: state => {
    return state.rejected_bets;
  },
  getMobileCartOpen: state => {
    return state.mobileCartOpen;
  },
  getCombinableMarkets: state => {
    return state.combinableMarkets;
  },
  getIsCartUpdating: state => {
    return state.isCartUpdating;
  },
  getIsCartOpen: state => {
    return state.isCartOpen;
  }
};

const actions = {
  async replaceOdds(context, payload) {
    console.log('[replaceOdds] Chiamato con payload:', payload);
    console.log(
      '[replaceOdds] Quote attuali nel carrello:',
      context.state.bet.odds.length
    );
    console.log(
      '[replaceOdds] unique_id delle quote nel carrello:',
      context.state.bet.odds.map(o => o.unique_id)
    );

    if (payload.odds.length > 0) {
      const newBetOdds = context.state.bet.odds;
      console.log(
        '[replaceOdds] Processing',
        payload.odds.length,
        'quote da aggiornare'
      );

      for (const odd of payload.odds) {
        console.log('[replaceOdds] Processing odd:', {
          source: odd.source,
          reason: odd.reason,
          hasNewOdd: !!odd.newOdd
        });

        switch (odd.reason) {
          case 'changed_odd_value':
          case 'changed_multiplicity':
            var index = findIndex(newBetOdds, function (odd_to_find) {
              const match = odd_to_find.unique_id == odd.source;
              if (!match) {
                console.log('[replaceOdds] Matching fallito:', {
                  searching: odd.source,
                  found: odd_to_find.unique_id,
                  typeSearching: typeof odd.source,
                  typeFound: typeof odd_to_find.unique_id
                });
              }
              return match;
            });
            console.log(
              '[replaceOdds] Index trovato per',
              odd.source,
              ':',
              index
            );
            if (index >= 0) {
              console.log('[replaceOdds] Aggiornando quota:', {
                source: odd.source,
                oldValue: newBetOdds[index].outcome_odd_value,
                newValue: odd.newOdd?.outcome_odd_value
              });
              newBetOdds[index] = odd.newOdd;
              console.log(
                '[replaceOdds] Quota aggiornata:',
                newBetOdds[index].outcome_odd_value
              );
            } else {
              console.error(
                '[replaceOdds] QUOTA NON TROVATA NEL CARRELLO:',
                odd.source
              );
              console.error(
                '[replaceOdds] Quote disponibili:',
                newBetOdds.map(o => ({
                  unique_id: o.unique_id,
                  type: typeof o.unique_id
                }))
              );
            }
            break;
          case 'disabled':
          case 'time_over':
            console.log(
              '[replaceOdds] Cercando quota da disabilitare:',
              odd.source
            );
            var odd_to_find = findLodash(newBetOdds, { unique_id: odd.source });
            if (odd_to_find) {
              console.log(
                '[replaceOdds] Quota trovata per disabilitare:',
                odd.source
              );
              odd_to_find.to_remove = true;
            } else {
              console.error(
                '[replaceOdds] QUOTA NON TROVATA PER DISABILITARE:',
                odd.source
              );
              console.error(
                '[replaceOdds] Quote disponibili:',
                newBetOdds.map(o => ({
                  unique_id: o.unique_id,
                  type: typeof o.unique_id
                }))
              );
            }
            break;
        }
      }
      console.log(
        '[replaceOdds] Committing SET_ODDS con',
        newBetOdds.length,
        'quote'
      );
      context.commit('SET_ODDS', newBetOdds);
      console.log(
        '[replaceOdds] Quote dopo commit:',
        context.state.bet.odds.map(o => ({
          unique_id: o.unique_id,
          outcome_odd_value: o.outcome_odd_value
        }))
      );
    } else {
      console.warn('[replaceOdds] payload.odds è vuoto o non valido');
    }
  },
  async updateSingleOdd(context, payload) {
    const { uniqueId, newOdd } = payload;
    const currentOdds = [...context.state.bet.odds];
    const index = currentOdds.findIndex(o => o.unique_id === uniqueId);
    console.log('[updateSingleOdd] currentOdds', currentOdds);
    console.log('[updateSingleOdd] index', index);
    console.log('[updateSingleOdd] newOdd PRIMA dello spread:', {
      newOdd: newOdd,
      hasChanged: 'changed' in newOdd,
      changedValue: newOdd.changed,
      newOddKeys: Object.keys(newOdd),
      newOddStringified: JSON.stringify(newOdd),
      changedPropertyDescriptor: Object.getOwnPropertyDescriptor(
        newOdd,
        'changed'
      ),
      allPropertyNames: Object.getOwnPropertyNames(newOdd)
    });
    if (index >= 0) {
      // Sostituisce completamente l'odd
      const oldOdd = currentOdds[index];
      // Preserva esplicitamente il campo changed se esiste
      const changedValue = newOdd.changed;
      currentOdds[index] = { ...newOdd };
      // Se changed esisteva in newOdd ma non è stato copiato dallo spread, aggiungilo esplicitamente
      if ('changed' in newOdd && !('changed' in currentOdds[index])) {
        console.warn(
          '[updateSingleOdd] Campo changed non copiato dallo spread, aggiungo esplicitamente'
        );
        currentOdds[index].changed = changedValue;
      } else if ('changed' in newOdd) {
        // Assicurati che il valore sia preservato
        currentOdds[index].changed = changedValue;
      }
      console.log('[updateSingleOdd] currentOdds[index] DOPO lo spread:', {
        index: index,
        uniqueId: uniqueId,
        oldOdd: oldOdd,
        newOddAfterSpread: currentOdds[index],
        hasChanged: 'changed' in currentOdds[index],
        changedValue: currentOdds[index].changed,
        newOddKeys: Object.keys(currentOdds[index]),
        newOddStringified: JSON.stringify(currentOdds[index]),
        changedPropertyDescriptor: Object.getOwnPropertyDescriptor(
          currentOdds[index],
          'changed'
        )
      });
      context.commit('SET_ODDS', currentOdds);
      const checkOdds = context.state.bet.odds;
      console.log('[updateSingleOdd] checkOdds DOPO il commit:', {
        checkOdds: checkOdds,
        updatedOdd: checkOdds[index],
        hasChanged: checkOdds[index] ? 'changed' in checkOdds[index] : false,
        changedValue: checkOdds[index] ? checkOdds[index].changed : undefined,
        updatedOddKeys: checkOdds[index] ? Object.keys(checkOdds[index]) : [],
        updatedOddStringified: checkOdds[index]
          ? JSON.stringify(checkOdds[index])
          : ''
      });
    }
  },
  async placeBet(context, payload) {
    return new Promise(async (resolve, reject) => {
      if (context.state.odds_sources.length > 0) {
        const betToVerify = {
          odds_sources: context.state.odds_sources,
          bet: {
            odds: context.state.bet.odds,
            type: context.state.bet.type
          }
        };

        let amountBet = 0.0;

        switch (context.state.bet.type) {
          case 'single':
          case 'multiple':
            betToVerify.bet._multiple_detail =
              context.state.bet._multiple_detail;
            amountBet = +context.state.bet._multiple_detail.amount;
            break;
          case 'integral':
            betToVerify.bet._integral_detail =
              context.state.bet._integral_detail;
            amountBet = +context.state.bet._integral_detail.amount_total;
            break;
          case 'system':
            betToVerify.bet._system_detail = context.state.bet._system_detail;
            betToVerify.bet.system_parts = context.state.bet.system_parts;
            amountBet = +context.state.bet._system_detail.amount_system;
            break;
        }

        const encryptedText = CryptoJS.AES.encrypt(
          JSON.stringify(context.state.odds_sources),
          process.env.VUE_APP_HASH_FORM
        ).toString();
        const userIdOfUserToPlayBetFor =
          context.rootGetters['user/getUserIdOfUserToPlayBetFor'];
        const loginOfUserToPlayBetFor =
          context.rootGetters['user/getLoginOfUserToPlayBetFor'];

        const userInfo = {
          id: context.rootGetters['user/getId'],
          login: context.rootGetters['user/getLogin'],
          agencyId: context.rootGetters['user/getAgencyNet'],
          agencyLogin: context.rootGetters['user/getAgencyLogin'],
          operatorId: context.rootGetters['user/getOperatorNet'],
          operatorLogin: context.rootGetters['user/getOperatorLogin']
        };

        const payload_request = {
          betContext: payload.betContext,
          bet_to_check: JSON.stringify(betToVerify),
          lang: payload.lang,
          accept_odds: payload.accept_odds,
          hash: encryptedText,
          type_user:
            context.rootGetters['user/getType'] == 4 ||
            context.rootGetters['user/getCashier']
              ? 'retail'
              : 'user',
          userInfo: userInfo
        };

        if (
          userIdOfUserToPlayBetFor != null &&
          loginOfUserToPlayBetFor != null
        ) {
          payload_request.playerId = +userIdOfUserToPlayBetFor;
          payload_request.playerLogin = loginOfUserToPlayBetFor.toString();

          const automaticRecharge =
            context.rootGetters['settings/getEnableAutoRecharge'];

          if (automaticRecharge === true) {
            const checkBalance = await context.dispatch(
              'user/getUserSportBalance',
              {
                customerId: context.rootGetters['settings/getCustomerId'],
                userId: +userIdOfUserToPlayBetFor
              },
              { root: true }
            );

            if (+checkBalance < +amountBet) {
              const valueToRecharge = +amountBet - +checkBalance;
              const responseRecharge = await context.dispatch(
                'user/depositTransfer',
                {
                  customer:
                    context.rootGetters['settings/getCustomerId'].toString(),
                  amount: valueToRecharge.toString(),
                  receiverIdUser: payload_request.playerId.toString(),
                  reference: context.rootGetters['user/getId'].toString(),
                  login: context.rootGetters['user/getLogin'].toString(),
                  nameUser: payload_request.playerLogin.toString(),
                  passCode: '123456', // todo this is a temporary payload... waiting for some fix on server side
                  eventDescription: 'Deposit'
                },
                { root: true }
              );
            }
          }
        }

        const url = `${context.rootGetters['settings/getBetApiUrl']}/cart/place-bet`;

        await axios
          .post(`${url}`, payload_request, {
            headers: {
              Authorization: `Bearer ${context.rootGetters['user/getToken']}`
            }
          })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject({ result: false });
            console.log(error);
          });
      } else {
        resolve({ error_code: 'event_not_avaiable' });
      }
    });
  },
  async placeBetChanged(context, payload) {
    // console.log('placeBetChanged');
  },
  async bookBet(context, payload) {
    return new Promise(async (resolve, reject) => {
      if (context.state.odds_sources.length > 0) {
        const betToVerify = {
          odds_sources: context.state.odds_sources,
          bet: {
            odds: context.state.bet.odds,
            type: context.state.bet.type
          }
        };
        switch (context.state.bet.type) {
          case 'single':
          case 'multiple':
            betToVerify.bet._multiple_detail =
              context.state.bet._multiple_detail;
            break;
          case 'integral':
            betToVerify.bet._integral_detail =
              context.state.bet._integral_detail;
            break;
          case 'system':
            betToVerify.bet._system_detail = context.state.bet._system_detail;
            betToVerify.bet.system_parts = context.state.bet.system_parts;
            break;
        }

        const payload_request = {
          betContext: payload.betContext,
          bet_to_check: JSON.stringify(betToVerify),
          lang: payload.lang
        };

        const url = `${context.rootGetters['settings/getUrlApi']}/cart/book-bet`;

        await axios
          .post(`${url}`, payload_request, {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject({ result: false });
            console.log(error);
          });
      } else {
        reject({ result: false });
      }
    });
  },
  async oddChangeFromSocketCart(context, payload) {
    if (context.state.odds_sources.length > 0 && !isEmpty(payload)) {
      const source_to_find = payload._attributes.event_id;
      const odds_to_refresh = [];

      for (const oddSource of context.state.odds_sources) {
        if (oddSource.includes(source_to_find)) {
          odds_to_refresh.push(oddSource);
        }
      }

      if (!isEmpty(odds_to_refresh)) {
        await Promise.all(
          Object.keys(odds_to_refresh).map(async index => {
            const odd_source = odds_to_refresh[index];
            const split = odd_source.split(';');
            let spec = '';

            let market = split[1];
            const outcome = split[2];

            if (split[1].includes('#')) {
              const spec_split = split[1].split('#');
              market = spec_split[0];
              spec = spec_split[1];
            }
            const newOdds = findLodash(payload.odds.market, function (mark) {
              if (spec != '') {
                return (
                  mark._attributes.id == market &&
                  mark._attributes.specifiers == spec
                );
              } else {
                return mark._attributes.id == market;
              }
            });

            if (newOdds != undefined) {
              const newOutcome = findLodash(newOdds.outcome, function (out) {
                return out._attributes.id == outcome;
              });

              const oldOutcome = findLodash(
                context.state.bet.odds,
                function (oldOut) {
                  return oldOut.unique_id == odd_source;
                }
              );

              if (newOutcome != undefined && oldOutcome != undefined) {
                // ToDo Update Cart from Server
                this.$root.$emit('forceUpdateOddsSummary');
                this.$root.$emit('forceUpdateSystem');
                this.$root.$emit('forceUpdateSingleMultiple');
                this.$root.$emit('forceUpdateIntegral');
              }
            }
          })
        );
      }
    }
  },
  async addOddToCart(context, payload) {
    console.log('addOddToCart', JSON.stringify(payload));
    const limit = 20;
    const oddObj = JSON.parse(JSON.stringify(payload.odd));
    const eventObj = payload.event;
    const sportObj = payload.sport;
    const categoryObj = payload.category;
    const tournamentObj = payload.tournament;

    if (context.state.bet.odds.length == 0) {
      context.state.created_at = new Date().getTime();
      if (
        context.state.bet.type == 'single' ||
        context.state.bet.type == 'multiple'
      ) {
        context.state.bet._multiple_detail.amount =
          context.state.settings.minAmount;
      } else if (context.state.bet.type == 'integral') {
        context.state.bet._integral_detail.amount =
          context.state.settings.minAmount;
      }
    }

    if (!context.state.odds_sources.includes(oddObj.unique_id)) {
      if (
        context.state.bet.odds.length >= limit &&
        context.state.bet.type == 'system'
      ) {
        context.dispatch('settings/setSnackbar', true, { root: true });
        context.dispatch('settings/setSnackbarText', 'maximumOddsSystem', {
          root: true
        });
        return;
      }

      context.commit('ADD_ODD_SOURCE', oddObj.unique_id);
      const odd = await cartHandler.refactorOdd(
        oddObj,
        eventObj,
        sportObj,
        categoryObj,
        tournamentObj
      );

      if (context.state.settings.integral) {
        context.commit('ADD_ODD', odd);
      } else {
        const checkDoubleOdds = await findLodash(context.state.bet.odds, {
          event_source: oddObj.event_source
        });

        if (checkDoubleOdds != undefined && !isEmpty(checkDoubleOdds)) {
          await context.dispatch('removeOddFromCart', checkDoubleOdds);
        }
        context.commit('ADD_ODD', odd);
      }
    } else {
      await context.dispatch('removeOddFromCart', oddObj);
      await context.dispatch('checkFixedBaseSystem', oddObj);
    }
    await context.dispatch('refreshCart');

    // fix me this is a working around problem

    if (context.state.bet.odds.length > 0) {
      await context.dispatch('setIsCartOpen', true);
    } else {
      await context.dispatch('setIsCartOpen', false);
    }

    setTimeout(() => {
      EventBus.$emit('refreshedCartWithOdd'); // fix me this is a working around problem
    }, 20);
  },

  /* SERVER SIDE V3 */

  async addOddToCartV3(context, payload) {
    console.log('OLDaddOddToCartV3');
    var limit = 20;
    var marketObj =
      payload.oddMarket != null
        ? JSON.parse(JSON.stringify(payload.oddMarket))
        : null;
    var oddObj = JSON.parse(JSON.stringify(payload.odd));
    var eventObj = payload.event;
    var sportObj = payload.sport;
    var categoryObj = payload.category;
    var tournamentObj = payload.tournament;

    if (context.state.bet.odds.length == 0) {
      context.state.created_at = new Date().getTime();
      if (
        context.state.bet.type == 'single' ||
        context.state.bet.type == 'multiple'
      ) {
        context.state.bet._multiple_detail.amount =
          context.state.settings.minAmount;
      } else if (context.state.bet.type == 'integral') {
        context.state.bet._integral_detail.amount =
          context.state.settings.minAmount;
      }
    }

    if (!context.state.odds_sources.includes(oddObj.unique_id)) {
      if (
        context.state.bet.odds.length >= limit &&
        context.state.bet.type == 'system'
      ) {
        context.dispatch('settings/setSnackbar', true, { root: true });
        context.dispatch('settings/setSnackbarText', 'maximumOddsSystem', {
          root: true
        });
        return;
      }

      context.commit('ADD_ODD_SOURCE', oddObj.unique_id);
      const odd = await cartHandler.refactorOddV3(
        marketObj,
        oddObj,
        eventObj,
        sportObj,
        categoryObj,
        tournamentObj
      );

      if (context.state.settings.integral) {
        context.commit('ADD_ODD', odd);
      } else {
        var checkDoubleOdds = await findLodash(context.state.bet.odds, {
          event_source: oddObj.event_source
        });

        if (checkDoubleOdds != undefined && !isEmpty(checkDoubleOdds)) {
          await context.dispatch('removeOddFromCart', checkDoubleOdds);
        }

        context.commit('ADD_ODD', odd);
      }
    } else {
      await context.dispatch('removeOddFromCart', oddObj);
      await context.dispatch('checkFixedBaseSystem', oddObj);
    }

    await context.dispatch('refreshCart');
  },
  async removeOddFromCart(context, payload) {
    console.log('removeOddFromCart', payload);
    const odds = remove(context.state.bet.odds, function (odd) {
      return odd.unique_id != payload.unique_id;
    });
    console.log('removeOddFromCart odds', odds);
    await context.commit('SET_ODDS', odds);

    console.log('removeOddFromCart syncCartStatus');
    const active = remove(context.state.odds_sources, function (odd) {
      return odd != payload.unique_id;
    });
    console.log('removeOddFromCart active', active);
    await context.commit('SET_ODDS_SOURCE', active);
    await context.dispatch('refreshCart');
    return;
  },
  async acceptOdd(context, payload) {
    const odds = context.state.bet.odds;
    for (const odd of odds) {
      if (odd.unique_id == payload.unique_id) {
        delete odd.changed;
        delete odd.type_change;
        break;
      }
    }
    await context.commit('SET_ODDS', odds);
  },
  async acceptAllOdds(context, payload) {
    const odds = context.state.bet.odds;
    console.log('[acceptAllOdds] Odds PRIMA della rimozione di changed:', {
      oddsLength: odds.length,
      oddsWithChanged: odds.filter(o => o.changed === true),
      oddsWithChangedDetails: odds
        .filter(o => o.changed === true)
        .map(o => ({
          unique_id: o.unique_id,
          changed: o.changed,
          keys: Object.keys(o)
        }))
    });

    for (const odd of odds) {
      if (odd.changed) {
        console.log('[acceptAllOdds] Rimuovendo changed da odd:', {
          unique_id: odd.unique_id,
          changed: odd.changed
        });
        delete odd.changed;
        delete odd.type_change;
      }
    }

    console.log('[acceptAllOdds] Odds DOPO la rimozione di changed:', {
      oddsLength: odds.length,
      oddsWithChanged: odds.filter(o => o.changed === true),
      oddsDetails: odds.map(o => ({
        unique_id: o.unique_id,
        hasChanged: 'changed' in o,
        changedValue: o.changed,
        keys: Object.keys(o)
      }))
    });

    await context.commit('SET_ODDS', odds);
  },
  async checkFixedBaseSystem(context, payload) {
    const fixed_bases = context.state.bet._system_detail.fixed_bases;

    if (!fixed_bases.includes(payload.unique_id)) {
      if (fixed_bases.length < context.state.bet.odds.length - 2) {
        fixed_bases.push(payload.unique_id);
        await context.commit('SET_SYSTEM_FIXED_BASES', fixed_bases);
      } else {
        await context.commit('SET_SYSTEM_FIXED_BASES', []);
        await context.commit('SET_BET_TYPE', 'multiple');
      }
    } else {
      const new_fixed_bases = remove(
        context.state.bet._system_detail.fixed_bases,
        function (odd) {
          return odd != payload.unique_id;
        }
      );

      await context.commit('SET_SYSTEM_FIXED_BASES', new_fixed_bases);
    }

    await context.dispatch('refreshCart');
  },
  async setLoadingCart(context, payload) {
    context.commit('SET_LOADING_CART', payload.status);
  },
  async resetCart(context) {
    context.commit('RESET_CART');
    // Sincronizza cartStatus dopo il reset del carrello (rimuove tutte le chiavi)
  },
  async initCart(context) {
    const now = new Date().getTime();
    if (now - context.state.created_at > 3 * 3600000) {
      context.commit('RESET_CART');
    } else {
      await context.dispatch('refreshCart');
    }
  },
  async refreshCart(context) {
    console.log('[refreshCart] Odds PRIMA del refresh:', {
      oddsLength: context.state.bet.odds ? context.state.bet.odds.length : 0,
      odds: context.state.bet.odds,
      oddsWithChanged: context.state.bet.odds
        ? context.state.bet.odds.filter(o => o.changed === true)
        : [],
      oddsWithChangedDetails: context.state.bet.odds
        ? context.state.bet.odds
            .filter(o => o.changed === true)
            .map(o => ({
              unique_id: o.unique_id,
              changed: o.changed,
              keys: Object.keys(o)
            }))
        : []
    });
    const percentageTaxValueOnWon =
      context.rootGetters['settings/getPercentageTaxValueOnWon'];
    const allowIntegralLiveBet =
      context.rootGetters['settings/getAllowIntegralLiveBet'];

    const bet = await cartHandler.refreshCart(
      context.state.settings,
      context.state.bet,
      context.state.bonus_rules,
      context.state.odds_sources,
      context.state.combinableMarkets,
      percentageTaxValueOnWon,
      allowIntegralLiveBet
    );
    console.log('[refreshCart] Bet DOPO refreshCart (prima del commit):', {
      betOddsLength: bet.odds ? bet.odds.length : 0,
      betOdds: bet.odds,
      betOddsWithChanged: bet.odds
        ? bet.odds.filter(o => o.changed === true)
        : [],
      betOddsWithChangedDetails: bet.odds
        ? bet.odds
            .filter(o => o.changed === true)
            .map(o => ({
              unique_id: o.unique_id,
              changed: o.changed,
              keys: Object.keys(o)
            }))
        : []
    });
    context.commit('REFRESH_CART', bet);
    console.log('[refreshCart] Odds DOPO il commit REFRESH_CART:', {
      oddsLength: context.state.bet.odds ? context.state.bet.odds.length : 0,
      odds: context.state.bet.odds,
      oddsWithChanged: context.state.bet.odds
        ? context.state.bet.odds.filter(o => o.changed === true)
        : [],
      oddsWithChangedDetails: context.state.bet.odds
        ? context.state.bet.odds
            .filter(o => o.changed === true)
            .map(o => ({
              unique_id: o.unique_id,
              changed: o.changed,
              keys: Object.keys(o)
            }))
        : []
    });
    // Sincronizza cartStatus dopo il refresh del carrello
  },
  async setCartSettings(context, payload) {
    context.commit('SET_CART_SETTINGS', payload.settings);
  },
  async setBetType(context, payload) {
    context.commit('SET_BET_TYPE', payload.type);
  },
  async setSystemComboDetail(context, payload) {
    context.commit('SET_SYSTEM_PARTS', payload.system_parts);
  },
  async setSystemAmountToDivide(context, payload) {
    context.commit('SET_SYSTEM_AMOUNT_TO_DIVIDE', payload.amount);
  },
  async setSystemAmountEqual(context, payload) {
    context.commit('SET_SYSTEM_AMOUNT_EQUAL', payload.amount);
  },
  async fetchBookedBet(context, payload) {
    return new Promise(async (resolve, reject) => {
      if (payload.code != '') {
        const payload_request = {
          code: payload.code
        };

        const url = `${context.rootGetters['settings/getUrlApi']}/cart/get-booked-bet`;

        await axios
          .post(`${url}`, payload_request, {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          })
          .then(async res => {
            if (!res.data.result) {
              resolve({ result: false });
              return { result: false };
            } else {
              context.commit('RESET_CART');
              context.commit('SET_BET_FROM_BOOKING', res.data);
              context.dispatch('refreshCart');
              resolve({ result: true });
              return { result: true };
            }
          })
          .catch(error => {
            console.log(error);
            return { result: false };
            reject({ result: false });
          });
      } else {
        reject({ result: false, error: 'no_code_provided' });
      }
    });
  },
  async setOddsVariation(context, payload) {
    context.commit('SET_ODDS_VARIATION', payload);
  },
  async setOddsInCart(context, payload) {
    const clone = { ...payload };
    const odds_source = _.map(clone, 'unique_id');
    await context.commit('SET_ODDS_SOURCE', odds_source);
    context.commit('SET_ODDS', payload);
  },

  async setCreatedAtCart(context, payload) {
    context.commit('SET_CREATED_AT', payload);
  },
  async sendReviewBet(context, payload) {
    // deprecated delete me
    const url = `${context.rootGetters['settings/getUrlApi']}/cart/review-bet-by-user`;

    return await axios
      .post(
        `${url}`,
        { code: payload.code, mode: payload.mode },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(res => {
        return res;
      })
      .catch(error => {
        console.log(error);
      });
  },

  async addBetInAcceptance(context, payload) {
    context.commit('ADD_BET_IN_ACCEPTANCE', payload);
  },

  async removeBetFromAcceptance(context, payload) {
    context.commit('REMOVE_BET_IN_ACCEPTANCE', payload);
  },

  async removeBetFromAcceptanceByCode(context, betCode) {
    context.commit('REMOVE_BET_IN_ACCEPTANCE_BY_BET_CODE', betCode);
  },

  async addAcceptedBets(context, payload) {
    context.commit('ADD_ACCEPTED_BET', payload);
  },

  async removeBetFromAcceptedBets(context, payload) {
    context.commit('REMOVE_BET_FROM_ACCEPTED_BETS', payload);
  },

  async addRejectedBet(context, payload) {
    context.commit('ADD_REJECTED_BET', payload);
  },

  async removeBetFromRejectedBets(context, payload) {
    context.commit('REMOVE_BET_FROM_REJECTED_BETS', payload);
  },

  async addAcceptBetWithChanges(context, payload) {
    context.commit('ADD_ACCEPTED_BET_WITH_CHANGES', payload);
  },
  async removeBetFromAcceptedWithChange(context, payload) {
    context.commit('REMOVE_BET_FROM_ACCEPTED_WITH_CHANGE', payload);
  },
  async setMobileCartOpen(context, payload) {
    context.commit('SET_MOBILE_CART_OPEN', payload);
  },
  async setCombinableMarkets(context, payload) {
    context.commit('SET_COMBINABLE_MARKETS', payload);
  },
  async addCombinableMarkets(context, payload) {
    context.commit('ADD_COMBINABLE_MARKETS', payload);
  },
  async setIsCartUpdating(context, payload) {
    context.commit('SET_IS_CART_UPDATING', payload);
  },
  async setIsCartOpen(context, payload) {
    context.commit('SET_IS_CART_OPEN', payload);
  },

  async acceptsRevisedBet(context, payload) {
    const proxyUrl = context.rootGetters['settings/getProxyUrl'];

    if (proxyUrl == null) {
      return null;
    }

    const url = `${context.rootGetters['settings/getProxyUrl']}/cart/self/review/accept-bet`;

    return await axios
      .post(
        url,
        { code: payload.code },
        {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${getProxyAccessToken()}`
          }
        }
      )
      .then(res => {
        return res;
      })
      .catch(error => {
        console.log(error);
      });
  },

  async rejectRevisedBet(context, payload) {
    const proxyUrl = context.rootGetters['settings/getProxyUrl'];

    if (proxyUrl == null) {
      return null;
    }

    const url = `${context.rootGetters['settings/getProxyUrl']}/rocky-definition/definition/bet/review/self/reject`;

    return await axios
      .post(
        url,
        { code: payload.code },
        {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${getProxyAccessToken()}`
          }
        }
      )
      .then(res => {
        return res;
      })
      .catch(error => {
        console.log(error);
      });
  },

  async calculateCashout(context, payload) {
    try {
      console.log('calculateCashout action - payload:', payload);

      const { code, useMinuteEvaluation = true } = payload;
      const url = `${context.rootGetters['settings/getProxyUrl']}/cart/self/calculate-cashout`;

      const response = await axios.post(
        url,
        {
          code,
          useMinuteEvaluation
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getProxyAccessToken()}`
          }
        }
      );

      return response;
    } catch (error) {
      console.log('Error in calculateCashout');
      console.log(error);
      throw error;
    }
  },
  async defineCashout(context, payload) {
    try {
      console.log('defineCashout action - payload:', payload);

      const { code } = payload;
      const url = `${context.rootGetters['settings/getProxyUrl']}/cart/self/cashout`;

      const response = await axios.post(
        url,
        {
          code
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getProxyAccessToken()}`
          }
        }
      );
      return response;
    } catch (error) {
      console.log('Error in defineCashout');
      console.log(error);
      throw error;
    }
  }
};

const mutations = {
  ADD_ODD_SOURCE(state, payload) {
    state.odds_sources.push(payload);
  },
  ADD_ODD(state, payload) {
    state.bet.odds.push(payload);
  },
  SET_ODDS_SOURCE(state, payload) {
    state.odds_sources = payload;
  },
  SET_ODDS(state, payload) {
    console.log('[SET_ODDS] Payload ricevuto:', {
      payloadLength: payload ? payload.length : 0,
      payload: payload,
      oddsWithChanged: payload ? payload.filter(o => o.changed === true) : [],
      oddsWithChangedDetails: payload
        ? payload
            .filter(o => o.changed === true)
            .map(o => ({
              unique_id: o.unique_id,
              changed: o.changed,
              keys: Object.keys(o)
            }))
        : []
    });
    state.bet.odds = payload;
    console.log('[SET_ODDS] State.bet.odds dopo assegnazione:', {
      oddsLength: state.bet.odds ? state.bet.odds.length : 0,
      oddsWithChanged: state.bet.odds
        ? state.bet.odds.filter(o => o.changed === true)
        : [],
      oddsWithChangedDetails: state.bet.odds
        ? state.bet.odds
            .filter(o => o.changed === true)
            .map(o => ({
              unique_id: o.unique_id,
              changed: o.changed,
              keys: Object.keys(o)
            }))
        : []
    });
  },
  SET_LOADING_CART(state, payload) {
    state.loading = payload;
  },
  REFRESH_CART(state, payload) {
    console.log('[REFRESH_CART] Payload ricevuto:', {
      payloadOddsLength: payload.odds ? payload.odds.length : 0,
      payloadOdds: payload.odds,
      payloadOddsWithChanged: payload.odds
        ? payload.odds.filter(o => o.changed === true)
        : [],
      payloadOddsWithChangedDetails: payload.odds
        ? payload.odds
            .filter(o => o.changed === true)
            .map(o => ({
              unique_id: o.unique_id,
              changed: o.changed,
              keys: Object.keys(o)
            }))
        : []
    });
    console.log("[REFRESH_CART] State.bet.odds PRIMA dell'assegnazione:", {
      oddsLength: state.bet.odds ? state.bet.odds.length : 0,
      oddsWithChanged: state.bet.odds
        ? state.bet.odds.filter(o => o.changed === true)
        : []
    });
    state.bet = payload;
    console.log("[REFRESH_CART] State.bet.odds DOPO l'assegnazione:", {
      oddsLength: state.bet.odds ? state.bet.odds.length : 0,
      odds: state.bet.odds,
      oddsWithChanged: state.bet.odds
        ? state.bet.odds.filter(o => o.changed === true)
        : [],
      oddsWithChangedDetails: state.bet.odds
        ? state.bet.odds
            .filter(o => o.changed === true)
            .map(o => ({
              unique_id: o.unique_id,
              changed: o.changed,
              keys: Object.keys(o)
            }))
        : []
    });
  },
  RESET_CART(state) {
    state.created_at = 0;
    state.odds_sources = [];

    state.bet.check = true;
    state.bet.errors = [];
    state.bet.errors_multi_info = [];
    state.bet.warnings = [];
    state.bet.integral_parts = [];
    state.bet.odds = [];
    state.bet.system_parts = [];
    state.bet.type = 'single';
    state.bet.context = '';

    // single or multiple
    state.bet._multiple_detail.amount = state.settings.minAmount;
    state.bet._multiple_detail.bonus = 0.0;
    state.bet._multiple_detail.bonus_percentage = 0;
    state.bet._multiple_detail.multiplicity = 0;
    state.bet._multiple_detail.odds_total = 0;
    state.bet._multiple_detail.profit = 0;
    state.bet._multiple_detail.winning = 0;
    state.bet._multiple_detail.winning_total = 0;

    // integral
    state.bet._integral_detail.amount = state.settings.minAmount;
    state.bet._integral_detail.amount_total = state.settings.minAmount;
    state.bet._integral_detail.bonus_percentage = 0;
    state.bet._integral_detail.bonus_max = 0.0;
    state.bet._integral_detail.bonus_min = 0.0;
    state.bet._integral_detail.combinations = 0;
    state.bet._integral_detail.multiplicity = 0;
    state.bet._integral_detail.odds_total_max = 0.0;
    state.bet._integral_detail.odds_total_max = 0.0;
    state.bet._integral_detail.profit_max = 0.0;
    state.bet._integral_detail.profit_min = 0.0;
    state.bet._integral_detail.winning_max = 0.0;
    state.bet._integral_detail.winning_min = 0.0;
    state.bet._integral_detail.winning_total_max = 0.0;
    state.bet._integral_detail.winning_total_min = 0.0;

    // system
    state.bet._system_detail.amount_system = 0.0;
    state.bet._system_detail.amount_system_to_divide = null;
    state.bet._system_detail.amount_system_equal = null;
    state.bet._system_detail.bonus_max = 0.0;
    state.bet._system_detail.bonus_min = 0.0;
    state.bet._system_detail.combinations = 0;
    state.bet._system_detail.fixed_bases = [];
    // state.bet._system_detail.multiplicity = 0
    // state.bet._system_detail.odds_total_max = 0.00
    // state.bet._system_detail.odds_total_min = 0.00
    // state.bet._system_detail.profit_max = 0.00
    // state.bet._system_detail.profit_min = 0.00
    state.bet._system_detail.winning_max = 0.0;
    state.bet._system_detail.winning_min = 0.0;
    state.bet._system_detail.winning_total_max = 0.0;
    state.bet._system_detail.winning_total_min = 0.0;
    state.bet._system_detail.winning_all = 0.0;
  },
  SET_CART_SETTINGS(state, payload) {
    const cart_settings = findLodash(payload, {
      scope: 'cart',
      type: 'cart',
      source: 'betconsole'
    });
    Object.assign(state.settings, cart_settings.detail);
    state.bonus_rules = [];
    filter(payload, function (rule) {
      if (rule.scope == 'cart' && rule.type == 'cart_bonus') {
        const source_split = rule.source.split('#');
        rule.detail.context = parseInt(source_split[1]);

        state.bonus_rules.push(rule.detail);
      }
    });
  },
  SET_BET_TYPE(state, payload) {
    state.bet.type = payload;
  },
  SET_SYSTEM_PARTS(state, payload) {
    state.bet.system_parts = [...payload];
  },
  SET_SYSTEM_FIXED_BASES(state, payload) {
    state.bet._system_detail.fixed_bases = [...payload];
  },
  SET_SYSTEM_AMOUNT_TO_DIVIDE(state, payload) {
    state.bet._system_detail.amount_system_to_divide = payload;
  },
  SET_SYSTEM_AMOUNT_EQUAL(state, payload) {
    state.bet._system_detail.amount_system_equal = payload;
  },
  SET_BET_FROM_BOOKING(state, payload) {
    const betObj = JSON.parse(JSON.stringify(payload.result));
    state.bet.context = betObj.bet_context;
    state.bet.type = betObj.type;
    state.bet.odds = betObj.odds;
    state.odds_sources = betObj.odds_sources;

    switch (betObj.type) {
      case 'single':
      case 'multiple':
        {
          state.bet._multiple_detail = betObj._multiple_detail;
        }
        break;
      case 'integral':
        {
          state.bet._integral_detail = betObj._integral_detail;
          state.bet.integral_parts = betObj.integral_parts;
        }
        break;
      case 'system':
        {
          state.bet._system_detail = betObj._system_detail;
          state.bet.system_parts = betObj.system_parts;
        }
        break;
    }
  },
  SET_ODDS_VARIATION: (state, value) => {
    state.odds_variation = value;
  },

  ADD_CART_ERROR: (state, payload) => {
    if (!payload || !payload.message) {
      return;
    }
    // Verifica che l'errore non sia già presente per evitare duplicati
    const errorExists = state.bet.errors.some(
      error => error.message === payload.message
    );
    if (!errorExists) {
      state.bet.errors.push({
        message: payload.message,
        value: payload.value
      });
    }
  },

  REMOVE_CART_ERROR: (state, payload) => {
    if (!payload || !payload.message) {
      return;
    }
    // Rimuove l'errore con il messaggio specificato
    state.bet.errors = state.bet.errors.filter(
      error => error.message !== payload.message
    );
  },

  SET_CREATED_AT: (state, value) => {
    state.created_at = value;
  },

  setAcceptingBets: (state, value) => {
    state.accepting_bets = value;
  },

  ADD_BET_IN_ACCEPTANCE: (state, value) => {
    state.accepting_bets.push(value);
  },

  REMOVE_BET_IN_ACCEPTANCE: (state, payload) => {
    const betCodeToRemove = payload.code;
    state.accepting_bets = state.accepting_bets.filter(bet => {
      return bet.code != betCodeToRemove;
    });
  },

  REMOVE_BET_IN_ACCEPTANCE_BY_BET_CODE: (state, betCode) => {
    const betCodeToRemove = betCode;
    state.accepting_bets = state.accepting_bets.filter(bet => {
      return bet.code != betCodeToRemove;
    });
  },

  ADD_ACCEPTED_BET: (state, payload) => {
    state.accepted_bets.push(payload);
  },

  ADD_ACCEPTED_BET_WITH_CHANGES: (state, payload) => {
    state.accepted_with_change.push(payload);
  },

  REMOVE_BET_FROM_ACCEPTED_BETS: (state, betCode) => {
    state.accepted_bets = state.accepted_bets.filter(bet => {
      return bet.code != betCode;
    });
  },

  ADD_REJECTED_BET: (state, payload) => {
    state.rejected_bets.push(payload);
  },

  REMOVE_BET_FROM_REJECTED_BETS: (state, betCode) => {
    state.rejected_bets = state.rejected_bets.filter(bet => {
      return bet.code != betCode;
    });
  },

  REMOVE_BET_FROM_ACCEPTED_WITH_CHANGE: (state, betCode) => {
    state.accepted_with_change = state.accepted_with_change.filter(bet => {
      return bet.code != betCode;
    });
  },

  SET_MOBILE_CART_OPEN: (state, status) => {
    state.mobileCartOpen = status;
  },
  SET_COMBINABLE_MARKETS(state, payload) {
    state.combinableMarkets = payload;
  },
  ADD_COMBINABLE_MARKETS(state, payload) {
    const objIndex = state.combinableMarkets.findIndex(el => {
      return el.tournamentId === payload.tournamentId;
    });

    if (objIndex != -1) {
      state.combinableMarkets[objIndex] = payload;
    } else {
      state.combinableMarkets.push(payload);
    }
  },
  SET_IS_CART_UPDATING(state, payload) {
    state.isCartUpdating = payload != null ? payload : false;
  },
  SET_IS_CART_OPEN(state, payload) {
    state.isCartOpen = payload;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
